import React from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
// import cookie from 'react-cookies'
import { getDocs, collection } from "firebase/firestore";

var user_configuration = {
    shape: "circle", //could be "circle" or "square"
    initial_size: "1px", //initial size of the stars
    final_size: "5px", //final size of the stars after expansion
    expand_speed: "1s", //how fast the stars get bigger, in milliseconds
    fade_delay: "1s", //how long until the star fades out
    fade_duration: "1s", //how long the star fades for
    colors: ["hsla(62, 50%,50%, 0.5)", "rgba(255,255,255,0.5)", "hsla(180, 72%, 52%, 0.5)"], //The variety of colors of the stars. Can be any CSS complient color (eg. HEX, rgba, hsl)
    frequency: 100, //how often a new wave of stars pop-out (in milliseconds. Bigger==longer)
    density: 15,//how many stars pop out per wave
    keep_lit: false, //whether the stars disappear after they are created
    rotation: true, //whether the stars rotate through out their expansion
    coverage: 1, //how much of the element's area the stars will show up in (0-1)
    target_class: '.starlight', //the elements the script will target based on the class name
    custom_svg: "" //if you want to use a custom svg with a shape of a star instead (not supported yet)
};

var advanced_configuration = {
    expand_transition_timing: "linear", //could be ease, ease-in, ease-out, etc
    expand_delay: "1s",  //how long until the star starts to expand
    rotation_transition_timing: "linear",  //could be ease, ease-in, ease-out, etc
    rotation_angle: "360deg", //up to how much to rotate to
    rotation_duration: "1s", //how long the rotation will take place
    rotation_delay: "0s", //how long until rotation starts
    fade_transition_timing: "linear", //could be ease, ease-in, ease-out, etc
    z_index: 0 //the stars are absolutely positioned, so you can give them a z-index of whatever you wish
};

function Star(width, height) {
    //the offsets are required so that when a user specifies a coverage, the coverage is based around the center of the div, and not the top left
    let leftOffset = Math.round((width - width * user_configuration.coverage) / 2);
    let topOffset = (height - Math.round(height * user_configuration.coverage)) / 2;
    this.xposition = Math.floor(Math.random() * width * user_configuration.coverage) + leftOffset;
    this.yposition = Math.floor(Math.random() * height * user_configuration.coverage) + topOffset;
}

Star.prototype.create = function (parent_element, id) {
    //The container is there so that when the stars expand they exapand around the center
    var star = $('<div></div>');
    var star_container = $('<div id="starlight-star' + id + '"></div>');
    // star_container.attr("id","star"+id);
    star_container.append(star);

    //so the star stays centered as its container expands
    star.css({
        position: "absolute",
        top: "-50%",
        left: "-50%",
        width: "100%",
        height: "100%"
    });

    //the initial CSS properties of the star, including color, position, and size
    star_container.css({
        width: user_configuration.initial_size,
        height: user_configuration.initial_size,
        position: 'absolute',
        top: this.yposition,
        left: this.xposition,
        "z-index": advanced_configuration.z_index
    });

    //sets transition css properties of the star
    setTimeout(function () {
        star_container.css({ //size expand properties
            transition: "height " + user_configuration.expand_speed + " " + advanced_configuration.expand_transition_timing + " " + advanced_configuration.expand_delay + "," +
                "width " + user_configuration.expand_speed + " " + advanced_configuration.expand_transition_timing + " " + advanced_configuration.expand_delay,
            width: user_configuration.final_size,
            height: user_configuration.final_size
        });

        //because transition properties override each other, have to create a variable for transition and append transitions on to it
        if (user_configuration.rotation) { //rotation properties
            star.css({
                transform: "rotate(" + advanced_configuration.rotation_angle + ")"
            });
            var transition = advanced_configuration.rotation_duration + " " + advanced_configuration.rotation_transition_timing + " " + advanced_configuration.rotation_delay;
        }

        if (!user_configuration.keep_lit) {//fading properties
            star.css({
                opacity: 0
            });
            if (transition) {
                transition += ",opacity " + user_configuration.fade_duration + " " + advanced_configuration.fade_transition_timing + " " + user_configuration.fade_delay;
            }
            else {
                transition = "opacity " + user_configuration.fade_duration + " " + advanced_configuration.fade_transition_timing + " " + user_configuration.fade_delay;
            }

            //removes the element from the dom after it fades out
            setTimeout(function () {
                $("#starlight-star" + id).remove();
            }, css_time_to_milliseconds(user_configuration.fade_duration) + css_time_to_milliseconds(user_configuration.fade_delay));
        }

        if (transition) {
            star.css({
                transition: transition
            });
        }

    }, 10);

    //sets shape and color of the star
    if (user_configuration.shape === 'circle') {
        star.css('border-radius', '50%');
    }
    if (user_configuration.custom_svg === '' || user_configuration.custom_svg === false) {
        star.css('background-color', user_configuration.colors[Math.floor(Math.random() * user_configuration.colors.length)]); //picks one of the colors
    }
    parent_element.append(star_container);
};

function css_time_to_milliseconds(time_string) {
    var num = parseFloat(time_string, 10),
        unit = time_string.match(/m?s/),
        milliseconds;

    if (unit) {
        unit = unit[0];
    }

    switch (unit) {
        case "s": // seconds
            milliseconds = num * 1000;
            break;
        case "ms": // milliseconds
            milliseconds = num;
            break;
        default:
            milliseconds = 0;
            break;
    }

    return milliseconds;
}


export default class PrivatePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            faction: "sun",
            eggs: "1",
            discord: null,
            wallet: null,
            hasErr: false,
            hasSuc: false,
            totalEggs: 0,
            totalUsers: 0,
            users: {},
        }
    }

    async componentDidMount() {
        var id = 0;
        //traverses all of the elements with a class of 'starlight'
        $(user_configuration.target_class).each(function (index) {
            var currentElement = $(this);
            var width = currentElement.width();
            var height = currentElement.height();
            setInterval(function () { //creates the stars based on the frequency and desired density
                for (var i = 0; i < user_configuration.density; i++) {
                    var newStar = new Star(width, height);
                    newStar.create(currentElement, id);
                    newStar = null; //just in case so the garbage collector clears this value up
                    id++;
                }
            }, user_configuration.frequency);
        });

        let users = {};

        const snapshot2 = await getDocs(collection(this.props.db, "withoutDiscord"));
        snapshot2.forEach((doc2) => {
            users[doc2.id] = doc2.data()
            if (doc2.data().faction === "sun") { users[doc2.id].faction = 0; }
            if (doc2.data().faction === "ocean") { users[doc2.id].faction = 1; }
            if (doc2.data().faction === "life") { users[doc2.id].faction = 2; }
            if (doc2.data().faction === "death") { users[doc2.id].faction = 3; }
            if (doc2.data().faction === "astral") { users[doc2.id].faction = 4; }
            if (doc2.data().eggs === ">5") { users[doc2.id].eggs = 6; }
            users[doc2.id].eggs = parseInt(users[doc2.id].eggs)
        });

        const snapshot = await getDocs(collection(this.props.db, 'withDiscord'));
        snapshot.forEach((doc) => {
            users[doc.id] = doc.data()
            if (doc.data().faction === "sun") { users[doc.id].faction = 0; }
            if (doc.data().faction === "ocean") { users[doc.id].faction = 1; }
            if (doc.data().faction === "life") { users[doc.id].faction = 2; }
            if (doc.data().faction === "death") { users[doc.id].faction = 3; }
            if (doc.data().faction === "astral") { users[doc.id].faction = 4; }
            if (doc.data().eggs === ">5") { users[doc.id].eggs = 6; }
            users[doc.id].eggs = parseInt(users[doc.id].eggs)
        });

        this.setState({
            users,
        })
    }

    dumpWithDiscord() {
        if (this.state.users) {
            var toArray = Object.values(this.state.users)
            var sortedByFac = [...toArray].sort((a, b) => a.faction - b.faction)
            var postSort = {
                ...sortedByFac
            }

            return Object.keys(postSort).map((f) => {
                let x = postSort[f];
                let factionz = "";

                if (x.faction === 0) {
                    factionz = "Sun"
                } else if (x.faction === 1) {
                    factionz = "Ocean"
                } else if (x.faction === 2) {
                    factionz = "Life"
                } else if (x.faction === 3) {
                    factionz = "Death"
                } else if (x.faction === 4) {
                    factionz = "Astral"
                }
                let teggs = x.eggs;
                if (teggs === 6) {
                    teggs = "> 5"
                }
                return (<div className="linedUp">
                    {x.wallet.substring(0, 9)}...
                    <span style={{ position: "absolute", right: "155px" }}>
                        {factionz} {teggs}
                    </span>
                </div>)
            })
        }
    }

    topMainText() {
        var totalEggs = 0;
        var users = 0;
        let sun = 0;
        let ocean = 0;
        let life = 0;
        let death = 0;
        let astral = 0;
        if (this.state.users) {

            Object.keys(this.state.users).map((f, k) => {
                let x = this.state.users[f];
                users = users + 1;
                if (x.eggs === 1) {
                    totalEggs = totalEggs + 1;
                } else if (x.eggs === 2) {
                    totalEggs = totalEggs + 2;
                } else if (x.eggs === 3) {
                    totalEggs = totalEggs + 3;
                } else if (x.eggs === 4) {
                    totalEggs = totalEggs + 4;
                } else if (x.eggs === 5) {
                    totalEggs = totalEggs + 5;
                } else if (x.eggs === 6) {
                    totalEggs = totalEggs + 6;
                }
                if (x.faction === 0) {
                    sun = sun + 1;
                }
                if (x.faction === 1) {
                    ocean = ocean + 1;
                }
                if (x.faction === 2) {
                    life = life + 1;
                }
                if (x.faction === 3) {
                    death = death + 1;
                }
                if (x.faction === 4) {
                    astral = astral + 1;
                }
                return null;
            })
        }
        return (
            <>
                <h1 className="maintext">
                    {users} Users want {totalEggs} Eggs
                </h1>
                <h1 className="submaintext alternate1">
                    <span role="img" aria-label="Sun">☀️</span>{sun}
                    <span role="img" aria-label="Tide">🌊</span>{ocean}
                    <span role="img" aria-label="Broccoli">🥦</span>{life}
                    <span role="img" aria-label="Skull">💀</span>{death}
                    <span role="img" aria-label="Crystal Ball">🔮</span>{astral}
                </h1>
            </>
        )
    }

    render() {
        return (
            <>
                {/* <Helmet>
                    <title>World of Ether | Whitelist</title>
                </Helmet> */}
                <div id="jumboimgz" className="altJumb">
                    <img id="shipz" src="https://woe2.s3.amazonaws.com/spaceship22.png" alt="Space-ship with smoke" />
                    <img id="moonz" src="https://woe2.s3.amazonaws.com/twoplanets.png" alt="Two moons" />
                    <div id="roadmap">
                        <div className="starlight">
                            <div>
                                <div className="wrap">
                                    <div id="navigation">
                                        <div id="logo">
                                            <Link to="/">
                                                <img src="https://woe2.s3.amazonaws.com/logo.png" alt="logo" />
                                            </Link>
                                        </div>
                                        <div id="menu-right">
                                            <Link to="/roadmap">
                                                <div className={`mask3 ${this.props.lang}`}>
                                                    <div className="mask-inner">
                                                        ROADMAP
                                                        {/* {lang.collection[this.props.lang]} */}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div id="roadwrap">
                                        <div id="roady3" style={{ marginTop: 75 }} className="thin-wrap">
                                            {this.topMainText()}
                                            {this.state.hasErr ?
                                                <div className="errortext">
                                                    Please Connect a Web3 Wallet
                                                </div>
                                                :
                                                null
                                            }
                                            {this.state.hasSuc ?
                                                <div className="succtext">
                                                    Thanks For Submitting!
                                                </div>
                                                :
                                                null
                                            }
                                            {/* <div id="registrybox" className="privedit">
                                                {this.dumpWithDiscord()}
                                            </div> */}
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <div id="footer" className="imageless">
                                        <div className="footleft">
                                            <Link to="/"><img src="https://woe2.s3.amazonaws.com/logo.png" alt="logo" /></Link>
                                        </div>
                                        <div className="footright">
                                            © Copyright 2022
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }


}